module.exports = __webpack_public_path__ + "img/tp-link_pic2.35c2ef05.png";